module.exports = __webpack_public_path__ + "static/media/mgs2018year.0a483537.svg";